import OSS from "ali-oss";
import {getSTStoken} from "@/api/file"
import {calculateFileHash,getTokenFromStorage} from "@/utils/upload"
import store from "@/store"
export async function FileUpLoad(file) {debugger
  const res=await getSTStoken()
  console.log(res,'res');
const hash=await calculateFileHash(file)
console.log(hash,'hash');

const token=getTokenFromStorage()
     console.log(file);
    try {
 
      const client = new OSS({
          region: 'oss-cn-chengdu', // Specify the region in which the bucket is located.
          accessKeyId: res.access_key_id, // Replace with your actual Access Key ID.
          accessKeySecret: res.access_key_secret, // Replace with your actual Access Key Secret.
          stsToken: res.security_token,
          bucket: 'sxdatasets', // Specify the name of the bucket. Example: 'my-bucket-name'. 
        }); 
        console.log(client,'client');
        const file_attrs = {
          access_token: token,
          file_hash: hash,
      }
      const options = {}
      //   const options = {
      //     callback: {
      //         // 设置回调请求的服务器地址，例如http://oss-demo.aliyuncs.com:23450。
      //         url: 'http://47.109.206.151/v1/webhook/upload_file',
      //         // 设置发起回调时请求body的值。
      //         body: "{\"bucket\":${bucket},\"object\":${object},\"size\":${size},"
      //             + "\"file\":" + JSON.stringify(file_attrs) + "}",
      //         // 设置发起回调请求的Content-Type。
      //         contentType: 'application/json'
      //     }
      // }
 console.log(client,'client');
 console.log(file_attrs,'file_attrs');
 console.log(options,'options');
 const id=store.state.userInfo.id
        const r1 = await client.put(`${id}/dataset/${file.name}`, file,options);
        console.log(r1,'r1');
        return r1.name
 
        
      } catch (e) {
        console.error('error: %j', e);
      }
     
}